export enum AlcoholLockEvent {
  ALCOHOL_TEST_POSITIVE = 'Test pozytywny',
  ALCOHOL_TEST_NEGATIVE = 'Test negatywny',
  ALCOHOL_TEST_BYPASS_ON = 'Bypass On',
  ALCOHOL_TEST_BYPASS_OFF = 'Bypass Off',
  ALCOHOL_TEST_READY_TO_TEST = 'Gotowość do testu'
}
